import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        data-testid="auth-loading"
      >
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (status !== "authed") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (adminOnly && user?.role !== "admin") {
    return <Navigate to="/projects" replace />;
  }
  return children;
}
